var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faqs"},[_c('header',[_vm._v("FAQs")]),_c('div',{staticClass:"faq-list"},_vm._l((_vm.faqItems),function(faqItem){return _c('FAQItem',_vm._b({key:faqItem.id},'FAQItem',faqItem,false))}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }